import React from 'react';
import {
  VStack, Text, Icon, Box, Pressable, Heading,
} from '@gluestack-ui/themed';
import { ChevronDown, ChevronUp } from 'lucide-react-native';
import { useTranslation } from 'react-i18next';
import HtmlText from '../../../../../../common/components/HtmlText';

const COLLAPSED_LINES = 5;
const OVERFLOW_THRESHOLD = 96;

const EventTaskDescription = ({ description, isLocked, isOralExam = false }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = React.useState(false);
  const [contentHeight, setContentHeight] = React.useState(0);
  const hasMeasured = React.useRef(false);

  const handleLayout = React.useCallback((e) => {
    if (hasMeasured.current) return;
    hasMeasured.current = true;
    setContentHeight(e?.nativeEvent?.layout?.height ?? 0);
  }, []);

  if (isOralExam && !description?.trim()) {
    return null;
  }

  const isOverflowing = contentHeight > OVERFLOW_THRESHOLD;
  const sectionTitleKey = isOralExam
    ? 'student.eventTask.description.additionalCommentsTitle'
    : 'student.eventTask.description.title';

  const dimWhenLocked = isLocked && !isOralExam;

  return (
    <VStack space="xs" opacity={dimWhenLocked ? 0.7 : 1} testID="event-task-description">
      <Heading size="sm" mb="$1">
        {t(sectionTitleKey, isOralExam ? 'Additional comments' : 'Description')}
      </Heading>
      <Box onLayout={handleLayout}>
        <HtmlText
          content={description}
          fontSize={13}
          numberOfLines={!isExpanded && isOverflowing ? COLLAPSED_LINES : undefined}
        />
      </Box>

      {isOverflowing && (
        <Pressable
          onPress={() => setIsExpanded(!isExpanded)}
          alignSelf="flex-start"
          flexDirection="row"
          alignItems="center"
          hitSlop={8}
        >
          <Text size="xs" color="$primary600" fontWeight="medium">
            {isExpanded
              ? t('student.eventTask.description.showLess', 'Show less')
              : t('student.eventTask.description.showMore', 'Show more')}
          </Text>
          <Icon as={isExpanded ? ChevronUp : ChevronDown} size="xs" color="$primary600" ml="$1" />
        </Pressable>
      )}
    </VStack>
  );
};

export default EventTaskDescription;
